import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL_Calisto

export const axiosCto = axios.create({
    baseURL: API_URL,
    withCredentials: true
})
